import { computed } from "vue";
import { useStore } from "vuex";
import yup from "@component_path/inquiry_form_common_module/customValidation";

export const useEmploymentTypeField = (required, messages = {}) => {
  const fieldName = computed(() => "employment_type");
  const validator = yup
    .number()
    .integer()
    .requirement(
      required,
      messages["requirement"] || "希望雇用形態は必須項目です"
    );

  return { validator, fieldName };
};

export const useEmploymentTypeStore = () => {
  const store = useStore();

  const employmentType = computed(() => store.state.formData.employment_type);
  const employmentTypes = computed(
    () => store.state.masterData.employmentTypes
  );
  const employmentTypeText = computed(() => store.getters.employmentTypeText);
  const dispatcher = computed(() => "formData/setEmploymentType");

  return { employmentType, employmentTypes, employmentTypeText, dispatcher };
};
